import { type HTMLAttributes } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export type KbdProps = HTMLAttributes<HTMLElement>;

export const Kbd = ({ className, ...props }: KbdProps) => (
  <kbd
    className={cnTwMerge(
      "pointer-events-none inline-flex h-5 select-none items-center gap-0.5 rounded border border-border/primary bg-background/primary px-1.5 font-mono text-xs font-medium text-text/secondary opacity-70",
      className,
    )}
    {...props}
  />
);
